<template>
  <div class="padding-y-24 padding-x-16">
    <Dropdown
      v-if="item.advanced"
      :value="form.actionType"
      :options="dropdownOptions"
      name="actionType"
      id="actionType"
      inputPlaceholder=""
      rowClass="margin-bottom-16"
      :hasRemoveIcon="false"
      @input="input"
      @change="changeActionType"
    />
    <Input
      v-if="!isBetween"
      :placeholder="$lang.numbers"
      :value="form.num"
      name="num"
      id="num"
      type="number"
      rowClass="margin-bottom-16"
      :vuelidateObj="$v.form.num"
      @input="inputNumber"
      @erase="eraseNum"
    />
    <Input
      v-if="isBetween"
      :placeholder="$lang.of"
      :value="form.numOf"
      name="numOf"
      id="numOf"
      type="number"
      rowClass="margin-bottom-16"
      :vuelidateObj="$v.form.numOf"
      @input="inputNumber"
      @erase="eraseNum"
    />
    <Input
      v-if="isBetween"
      :placeholder="$lang.to"
      :value="form.numTo"
      name="numTo"
      id="numTo"
      type="number"
      rowClass="margin-bottom-16"
      :vuelidateObj="$v.form.numTo"
      :disabled="!form.numOf"
      @input="inputNumber"
      @erase="eraseNum"
    />
  </div>
</template>

<script>
import inputMixin from "@/mixin/inputMixin.vue";
import { Dropdown, Input } from "@/components/re-design/forms";
import { pathOr, includes } from "ramda";

export default {
  mixins: [inputMixin],
  components: { Dropdown, Input },
  props: {
    item: {
      type: Object,
      default: null,
    },
    selectedFilter: {
      type: [Object, Array],
      default: null,
    },
  },
  validations() {
    return {
      form: {
        actionType: {},
        num: {},
        numOf: {},
        numTo: {},
      },
    };
  },
  data() {
    return {
      form: {
        actionType: {
          id: "eq",
          caption: this.$lang.equal,
        },
        num: null,
        numOf: null,
        numTo: null,
      },
      dropdownOptions: [
        {
          id: "eq",
          caption: this.$lang.equal,
        },

        {
          id: "gt",
          caption: this.$lang.bigger,
        },
        {
          id: "lt",
          caption: this.$lang.smaller,
        },
        {
          id: "gte",
          caption: this.$lang.bigger_or_equal,
        },
        {
          id: "lte",
          caption: this.$lang.smaller_or_equal,
        },
        {
          id: "between",
          caption: this.$lang.between,
        },
      ],
    };
  },
  computed: {
    isBetween() {
      return pathOr(null, ["id"], this.form.actionType) === "between";
    },
  },
  watch: {
    selectedFilter: {
      immediate: true,
      handler(data) {
        if (data) {
          this.generateSelectedFilter(data);
        }
      },
    },
  },
  methods: {
    pathOr,
    includes,
    resetAllCalender() {
      Object.keys(this.form).forEach((key) => {
        if (key !== "actionType") {
          this.form[key] = null;
        }
      });
      this.$v.$reset();
    },
    changeActionType() {
      this.resetAllCalender();
      this.generateServiceData();
    },
    inputNumber(key, value) {
      this.input(key, value);
      this.generateServiceData();
    },
    eraseNum(key) {
      this.input(key, null);
      if (key === "numOf") {
        this.input("numTo", null);
      }
      this.generateServiceData();
    },
    generateSelectedFilter(data) {
      const getOfFilterCache = Array.isArray(data);
      if (getOfFilterCache) {
        const actionTypeId = pathOr("eq", [0], data);
        this.form.actionType = this.dropdownOptions.find(
          (option) => option.id === actionTypeId
        );
        if (actionTypeId === "between") {
          this.form.num = null;
          this.form.numOf = pathOr(null, [1], data);
          this.form.numTo = pathOr(null, [2], data);
        } else {
          this.form.num = pathOr(null, [1], data);
          this.form.numOf = null;
          this.form.numTo = null;
        }
      } else {
        for (const key in data) {
          if (Object.hasOwnProperty.call(data, key)) {
            const value = data[key];
            this.input(key, value);
          }
        }
      }
    },
    generateServiceData() {
      this.$emit("getFilterData", this.item, this.form);
    },
  },
};
</script>
